import type { Measurer } from '@captionflow/caption-engine';

/**
 * Browser text measurer backed by an offscreen 2D context. Mirrors the worker's
 * node-canvas measurer so line breaks and word positions match between the live
 * preview and the exported video.
 */
let ctx: CanvasRenderingContext2D | null = null;

function getCtx(): CanvasRenderingContext2D {
  if (!ctx) {
    const canvas = document.createElement('canvas');
    const c = canvas.getContext('2d');
    if (!c) throw new Error('2D canvas context unavailable');
    ctx = c;
  }
  return ctx;
}

export const browserMeasurer: Measurer = {
  measure(text: string, font: string): number {
    const c = getCtx();
    c.font = font;
    return c.measureText(text).width;
  },
};
